import React from 'react'

import { StarNotificationFragment } from '@sketch/gql-types'

import { DocumentTileMedia } from './DocumentTileMedia'
import { StarIcon } from './StarPreview.styles'
import {
  Card,
  IconTile,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface StarPreviewProps {
  notification: StarNotificationFragment
}

export const StarPreview = ({ notification }: StarPreviewProps) => {
  const { share, workspace } = notification

  if (!share) return null

  // Temporary disable the thumbnail fetching because of a production issue
  // https://sketch.slack.com/archives/C04851ZU8FM/p1783086250683029?thread_ts=1783006390.487219&cid=C04851ZU8FM
  //
  // const thumbnail = thumbnailForPreviewFile(
  //   share.version?.document?.previewFile
  // )

  const thumbnail = null

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <IconTile aria-hidden>
            <StarIcon />
          </IconTile>
          <TileTitle>New version</TileTitle>
        </Tile>

        <Separator />

        <Tile>
          <DocumentTileMedia src={thumbnail} alt={`Preview of ${share.name}`} />
          <TileTitle>{share.name}</TileTitle>
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>
    </Card>
  )
}
